import { RecommendationSliders } from '@xp-utilities/web';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import RecommendationsContextProvider from '../../context/RecommendationsContextProvider';
import BreakpointContext from '../../context/breakpoint';
import parsePlacementIds from '../../tools/parsePlacementIds';
import useFeatureFlags from '../AutoSuggestResult/hooks/useFeatureFlags';

const Recommendations = ({
  clientId, handleOnProductClick, placementIds, mode = 'slider', styles = '', queryOptions,
}) => {
  const { recommendationsHideSwatchesMasterFlag } = useFeatureFlags();
  const breakpoints = useContext(BreakpointContext);
  const placements = parsePlacementIds(placementIds, breakpoints);
  const recommendationsProps = {
    clientId,
    placements,
  };

  return (
    <RecommendationsContextProvider
      id={recommendationsProps.clientId}
      recommendationsHideSwatchesMasterFlag={recommendationsHideSwatchesMasterFlag}
    >
      <div
        className={styles}
        data-recommendations-client={recommendationsProps.clientId}
        data-testid={recommendationsProps.clientId}
        id={recommendationsProps.clientId}
      >
        <RecommendationSliders
          onProductClick={handleOnProductClick}
          placements={recommendationsProps.placements}
          queryOptions={queryOptions}
          useGrid={mode === 'grid'}
        />
      </div>
    </RecommendationsContextProvider>
  );
};

export default Recommendations;

Recommendations.propTypes = {
  clientId: PropTypes.string.isRequired,
  styles: PropTypes.string,
  handleOnProductClick: PropTypes.func.isRequired,
  placementIds: PropTypes.string.isRequired,
  mode: PropTypes.string,
  queryOptions: PropTypes.shape({
    variables: PropTypes.shape({
      searchTerm: PropTypes.string,
    }),
  }),
};
